module.exports = __webpack_public_path__ + "img/service_img_3.b381838e.png";